<template>
  <modal
    name="editor"
    :clickToClose="false"
    :resizable="true"
    :scrollable="true"
    :reset="true"
    height="auto"
    :width="modalWidth"
    :maxHeight="modalHeight"
  >
    <div
      class="dialogcontainer"
      v-if="editFileData.type == 'img' || editFileData.type == 'pdf'"
    >
      <div class="centeringparent">
        <img class="thumbnailpreview" v-bind:src="editFileData.requestUrl" />
      </div>
      <destinations v-model="editFileData.dest" />
      <ckeditor
        class="ck-editor-img-body"
        :editor="editor"
        @ready="onBodyEditorReady"
        @focus="onBodyEditorFocus"
        @blur="onBodyEditorBlur"
        v-model="editFileData.body"
        :config="headlineEditorConfig"
        @input="onEditorInput"
      ></ckeditor>
      <div v-if="bodyEditing" class="label">
        <p class="wordcount">
          {{ $t("editor.COUNTER_WORDS") }}: {{ bodyWordCount.words }}
          {{ $t("editor.COUNTER_CHARS") }}: {{ bodyWordCount.chars }}
        </p>
      </div>
      <div v-else class="label">
        <p class="wordcount">&nbsp;</p>
      </div>
    </div>
    <div
      class="dialogcontainer"
      v-else-if="editFileData.type == 'url' || editFileData.type == 'any'"
    >
      <p class="label">{{ $t("editor.FIELD_NAME") }}</p>
      <input
        class="field"
        v-model="editFileData.name"
        @change="onEditorInput"
      />
      <destinations v-model="editFileData.dest" />
      <p class="label">{{ $t("editor.FIELD_HEADLINE") }}</p>
      <ckeditor
        class="ck-editor_headline"
        @ready="onHeadlineEditorReady"
        @focus="onHeadlineEditorFocus"
        @blur="onHeadlineEditorBlur"
        :editor="editor"
        v-model="editFileData.headline"
        :config="headlineEditorConfig"
        @input="onEditorInput"
      ></ckeditor>
      <div v-if="headlineEditing" class="label">
        <p class="wordcount">
          {{ $t("editor.COUNTER_WORDS") }}:
          {{ headlineWordCount.words }}
          {{ $t("editor.COUNTER_CHARS") }}:
          {{ headlineWordCount.chars }}
        </p>
      </div>
      <div v-else class="label">
        <p class="wordcount">&nbsp;</p>
      </div>
      <p class="label">{{ $t("editor.FIELD_LEAD") }}</p>
      <ckeditor
        class="ck-editor_lead"
        @ready="onLeadEditorReady"
        @focus="onLeadEditorFocus"
        @blur="onLeadEditorBlur"
        :editor="editor"
        v-model="editFileData.lead"
        :config="leadEditorConfig"
        @input="onEditorInput"
      ></ckeditor>
      <div v-if="leadEditing" class="label">
        <p class="wordcount">
          {{ $t("editor.COUNTER_WORDS") }}: {{ leadWordCount.words }}
          {{ $t("editor.COUNTER_CHARS") }}:
          {{ leadWordCount.chars }}
        </p>
      </div>
      <div v-else class="label">
        <p class="wordcount">&nbsp;</p>
      </div>

      <!-- <img class="thumbnailpreview" v-bind:src="editFileData.requestUrl" /> -->
      <p class="label">{{ $t("editor.FIELD_BODY") }}</p>
      <ckeditor
        class="ck-editor_body"
        @ready="onBodyEditorReady"
        @focus="onBodyEditorFocus"
        @blur="onBodyEditorBlur"
        :editor="editor"
        v-model="editFileData.body"
        :config="editorConfig"
        @input="onEditorInput"
        :style="{ 'min-height': ckeditorBodyMinHeight }"
      ></ckeditor>
      <div v-if="bodyEditing" class="label">
        <p class="wordcount">
          {{ $t("editor.COUNTER_WORDS") }}: {{ bodyWordCount.words }}
          {{ $t("editor.COUNTER_CHARS") }}: {{ bodyWordCount.chars }}
        </p>
      </div>
      <div v-else class="label">
        <p class="wordcount">&nbsp;</p>
      </div>
    </div>
    <div class="buttonscontainer" align="center" style="padding: 6px">
      <button @click="onDiscard" class="quicktextbutton">
        {{ $t("editor.BUTTON_DISCARD") }}
      </button>
      <button @click="onSave" class="quicktextbutton">
        {{ $t("editor.BUTTON_SAVE") }}
      </button>
    </div>
  </modal>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import CKEditor from "@ckeditor/ckeditor5-vue";
import InlineEditor from "@ckeditor/ckeditor5-editor-inline/src/inlineeditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import AutoformatPlugin from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import BlockQuotePlugin from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder";
import EasyImagePlugin from "@ckeditor/ckeditor5-easy-image/src/easyimage";
import FileRepository from "@ckeditor/ckeditor5-upload/src/filerepository";
import HeadingPlugin from "@ckeditor/ckeditor5-heading/src/heading";
import ImageCaptionPlugin from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImagePlugin from "@ckeditor/ckeditor5-image/src/image";
import ImageStylePlugin from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageToolbarPlugin from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageUploadPlugin from "@ckeditor/ckeditor5-image/src/imageupload";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";
import destinations from "./destinations.vue";
import eventBus from "../services/eventBus";

Vue.use(VModal, { dialog: true });

const MODAL_WIDTH = 656;
const MODAL_HEIGHT = 656;

class MyUploadAdapter {
  constructor(loader, editor) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.editor = editor;
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open("POST", "/pictures", true);
    xhr.withCredentials = true;
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = "Couldn't upload file:" + ` ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      this.editor.fire("onNewImg", response);
      resolve({
        default: "/uploads/" + response.imglink
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();
    data.append("file", file);
    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    // server.onUploadProgress( data => {
    //     loader.uploadTotal = data.total;
    //     loader.uploaded = data.uploaded;
    // } );

    // // Return a promise that will be resolved when the file is uploaded.
    // return server.upload( loader.file );
    return this.loader.file.then(file => {
      return new Promise((resolve, reject) => {
        this._initRequest();
        this._initListeners(resolve, reject, file);
        this._sendRequest(file);
      });
    });
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }
}

function MyCustomUploadAdapterPlugin(editor) {
  const plg = editor.plugins.get("FileRepository");
  plg.createUploadAdapter = loader => {
    // Configure the URL to the upload script in your back-end here!
    return new MyUploadAdapter(loader, editor);
  };
}

var HtmlSanitizer = new (function () {
  var tagWhitelist_ = {
    A: true,
    ABBR: true,
    B: true,
    BLOCKQUOTE: true,
    BODY: true,
    BR: true,
    CENTER: true,
    CODE: true,
    DIV: true,
    EM: true,
    FONT: true,
    H1: true,
    H2: true,
    H3: true,
    H4: true,
    H5: true,
    H6: true,
    HR: true,
    I: true,
    IMG: true,
    LABEL: true,
    LI: true,
    OL: true,
    P: true,
    PRE: true,
    SMALL: true,
    SOURCE: true,
    SPAN: true,
    STRONG: true,
    TABLE: true,
    TBODY: true,
    TR: true,
    TD: true,
    TH: true,
    THEAD: true,
    UL: true,
    U: true,
    VIDEO: true
  };

  var contentTagWhiteList_ = { FORM: true }; //tags that will be converted to DIVs

  var attributeWhitelist_ = {
    align: true,
    color: true,
    controls: true,
    height: true,
    href: true,
    src: true,
    style: true,
    target: true,
    title: true,
    type: true,
    width: true
  };

  var cssWhitelist_ = {
    color: true,
    "background-color": true,
    "font-size": true,
    "text-align": true,
    "text-decoration": true,
    "font-weight": true
  };

  var schemaWhiteList_ = ["http:", "https:", "data:"]; //which "protocols" are allowed in "href", "src" etc

  var uriAttributes_ = { src: true, href: true, action: true };

  this.SanitizeHtml = function (input) {
    //firefox "bogus node" workaround
    if (input == "<br>") return "";

    var iframe = document.createElement("iframe");
    if (iframe["sandbox"] === undefined) {
      alert(
        "Your browser does not support sandboxed iframes. Please upgrade to a modern browser."
      );
      return "";
    }
    iframe["sandbox"] = "allow-same-origin";
    iframe.style.display = "none";
    document.body.appendChild(iframe); // necessary so the iframe contains a document
    var iframedoc = iframe.contentDocument || iframe.contentWindow.document;
    if (iframedoc.body == null) iframedoc.write("<body></body>"); // null in IE
    iframedoc.body.innerHTML = input;

    function makeSanitizedCopy(node) {
      if (node.nodeType == Node.TEXT_NODE) {
        var newNode = node.cloneNode(true);
      } else if (
        node.nodeType == Node.ELEMENT_NODE &&
        (tagWhitelist_[node.tagName] || contentTagWhiteList_[node.tagName])
      ) {
        //remove useless empty spans (lots of those when pasting from MS Outlook)
        if (
          (node.tagName == "SPAN" ||
            node.tagName == "B" ||
            node.tagName == "I" ||
            node.tagName == "U") &&
          node.innerHTML.trim() == ""
        ) {
          return document.createDocumentFragment();
        }

        if (contentTagWhiteList_[node.tagName]) {
          newNode = iframedoc.createElement("DIV"); //convert to DIV
        } else {
          newNode = iframedoc.createElement(node.tagName);

          for (var i = 0; i < node.attributes.length; i++) {
            var attr = node.attributes[i];
            if (attributeWhitelist_[attr.name]) {
              if (attr.name == "style") {
                for (var s = 0; s < node.style.length; s++) {
                  var styleName = node.style[s];
                  if (cssWhitelist_[styleName])
                    newNode.style.setProperty(
                      styleName,
                      node.style.getPropertyValue(styleName)
                    );
                }
              } else {
                if (uriAttributes_[attr.name]) {
                  //if this is a "uri" attribute, that can have "javascript:" or something
                  if (!startsWithAny(attr.value, schemaWhiteList_)) continue;
                }
                newNode.setAttribute(attr.name, attr.value);
              }
            }
          }
        }
        for (i = 0; i < node.childNodes.length; i++) {
          var subCopy = makeSanitizedCopy(node.childNodes[i]);
          newNode.appendChild(subCopy, false);
        }
      } else {
        newNode = document.createDocumentFragment();
      }
      return newNode;
    }

    var resultElement = makeSanitizedCopy(iframedoc.body, null);
    document.body.removeChild(iframe);
    return resultElement.innerHTML
      .replace(/<br[^>]*>(\S)/g, "<br>\n$1")
      .replace(/div><div/g, "div>\n<div"); //replace is just for cleaner code
  };

  function startsWithAny(str, substrings) {
    for (var i = 0; i < substrings.length; i++) {
      if (str.indexOf(substrings[i]) == 0) {
        return true;
      }
    }
    return false;
  }

  this.AllowedTags = tagWhitelist_;
  this.AllowedAttributes = attributeWhitelist_;
  this.AllowedCssStyles = cssWhitelist_;
  this.AllowedSchemas = schemaWhiteList_;
})();

export default {
  name: "editor",
  components: {
    ckeditor: CKEditor.component,
    destinations
  },
  props: {
    editFileData: {}
  },
  data: function () {
    return {
      dirty: false,
      editing: false,
      headlineEditing: false,
      leadEditing: false,
      bodyEditing: false,
      headlineWordCount: {
        words: 0,
        chars: 0
      },
      leadWordCount: {
        words: 0,
        chars: 0
      },
      bodyWordCount: {
        words: 0,
        chars: 0
      },
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      ckeditorBodyMinHeight: "200px",
      editor: InlineEditor,
      editorConfig: {
        fontFamily: "Arial",
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          BlockQuotePlugin,
          BoldPlugin,
          CKFinder,
          EasyImagePlugin,
          FileRepository,
          HeadingPlugin,
          ImageCaptionPlugin,
          ImagePlugin,
          ImageStylePlugin,
          ImageToolbarPlugin,
          ImageUploadPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          MediaEmbed,
          ParagraphPlugin,
          Table,
          TableToolbar,
          WordCount,
          MyCustomUploadAdapterPlugin
        ],
        toolbar: {
          items: [
            "heading",
            "bold",
            "italic",
            "blockQuote",
            "link",
            "numberedList",
            "bulletedList",
            "mediaEmbed",
            "insertTable",
            "undo",
            "redo"
          ]
        }
      },
      headlineEditorConfig: {
        fontFamily: "Arial",
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          BlockQuotePlugin,
          BoldPlugin,
          HeadingPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          MediaEmbed,
          ParagraphPlugin,
          Table,
          TableToolbar,
          WordCount
        ],
        toolbar: {
          items: [
            "heading",
            "bold",
            "italic",
            "blockQuote",
            "link",
            "numberedList",
            "bulletedList",
            "insertTable",
            "undo",
            "redo"
          ]
        }
      },
      leadEditorConfig: {
        fontFamily: "Arial",
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          BlockQuotePlugin,
          BoldPlugin,
          HeadingPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          MediaEmbed,
          ParagraphPlugin,
          Table,
          TableToolbar,
          WordCount
        ],
        toolbar: {
          items: [
            "heading",
            "bold",
            "italic",
            "blockQuote",
            "link",
            "numberedList",
            "bulletedList",
            "insertTable",
            "undo",
            "redo"
          ]
        }
      }
    };
  },
  created() {},
  methods: {
    async editFile() {
      this.modalWidth =
        window.innerWidth < MODAL_WIDTH ? window.innerWidth * 0.8 : MODAL_WIDTH;
      this.modalHeight =
        window.innerHeight < MODAL_HEIGHT
          ? window.innerHeight * 0.8
          : MODAL_HEIGHT;

      // when opening the dialog on display which is small we should reduce the
      // height of the ckeditor so we can show the save and dismiss buttons.
      let ckHeight = Math.round(this.modalHeight - 150);
      if (ckHeight > 400) {
        ckHeight = 400;
      }
      this.ckeditorBodyMinHeight = `${ckHeight}px`;

      // In the editor component the prop associated to modalWidth would not be immediately updated
      // so we give enough time to Vue to propagate the change
      // in this way the width of the dialog will be properly set
      await this.$nextTick();
      //HtmlSanitizer.AllowedTags['SECTION'] = true;
      HtmlSanitizer.AllowedTags["FIGURE"] = true;
      HtmlSanitizer.AllowedTags["ARTICLE"] = true;
      HtmlSanitizer.AllowedTags["FIGCAPTION"] = true;
      HtmlSanitizer.AllowedTags["figcaption"] = true;
      //var html = HtmlSanitizer.SanitizeHtml(this.editFileData.body);
      //this.editFileData.body = html;
      //alert(Array.from( this.editor.ui.componentFactory.names() ));
      this.editing = true;
      this.dirty = false;
      this.skipDirty = 0;
      this.$modal.show("editor");
    },
    onEditorInput() {
      if (this.skipDirty <= 0) {
        this.dirty = true;
      } else if (this.skipDirty > 0) {
        this.skipDirty -= 1;
      }
    },
    onSave() {
      this.editing = false;
      this.$modal.hide("editor");
      this.$emit("onSave");
    },
    onDiscard() {
      if (!this.dirty || window.confirm(this.$t("editor.DISCARD_MSG"))) {
        this.editing = false;
        this.$modal.hide("editor");
      }
    },
    isEditing() {
      return this.editing;
    },
    isNew() {
      return this.editFileData._id === undefined;
    },

    insertHTML(editor, html) {
      // See: https://ckeditor.com/docs/ckeditor5/latest/builds/guides/faq.html#where-are-the-editorinserthtml-and-editorinserttext-methods-how-to-insert-some-content
      const viewFragment = editor.data.processor.toView(html);
      const modelFragment = editor.data.toModel(viewFragment);
      const insertPosition = editor.model.document.selection.getFirstPosition();
      editor.model.insertContent(modelFragment, insertPosition);
      this.skipDirty += 1;
    },

    onHeadlineEditorReady(editor) {
      const wordCountPlugin = editor.plugins.get("WordCount");
      this.headlineWordCount.words = wordCountPlugin.words;
      this.headlineWordCount.chars = wordCountPlugin.characters;
      wordCountPlugin.on("update", (event, data) => {
        this.headlineWordCount.words = data.words;
        this.headlineWordCount.chars = data.characters;
      });
    },

    onHeadlineEditorFocus() {
      this.headlineEditing = true;
    },

    onHeadlineEditorBlur() {
      this.headlineEditing = false;
    },

    onLeadEditorReady(editor) {
      const wordCountPlugin = editor.plugins.get("WordCount");
      this.leadWordCount.words = wordCountPlugin.words;
      this.leadWordCount.chars = wordCountPlugin.characters;
      wordCountPlugin.on("update", (event, data) => {
        this.leadWordCount.words = data.words;
        this.leadWordCount.chars = data.characters;
      });
    },

    onLeadEditorFocus() {
      this.leadEditing = true;
    },

    onLeadEditorBlur() {
      this.leadEditing = false;
    },

    onBodyEditorReady(editor) {
      editor.on("onNewImg", (event, data) => {
        eventBus.$emit("onNewImg", data);
      });
      const wordCountPlugin = editor.plugins.get("WordCount");
      this.bodyWordCount.words = wordCountPlugin.words;
      this.bodyWordCount.chars = wordCountPlugin.characters;
      wordCountPlugin.on("update", (event, data) => {
        this.bodyWordCount.words = data.words;
        this.bodyWordCount.chars = data.characters;
      });
    },

    onBodyEditorFocus() {
      this.bodyEditing = true;
    },

    onBodyEditorBlur() {
      this.bodyEditing = false;
    }
  }
};
</script>
<style>
.dialogcontainer,
.buttonscontainer {
  background-color: #f0f0f0;
}

p.label {
  padding: 6px;
  margin: 0px;
  color: #28567e;
}
.field,
.ck-editor_headline,
.ck-editor_lead,
.ck-editor_body,
.ck-editor-img-body {
  border: 1px solid;
  border-color: transparent;
  margin-left: 6px;
  margin-right: 6px;

  background: #fff;
  box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0.15),
    1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  overflow: visible;
}
.wordcount {
  border: 1px solid;
  border-color: transparent;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 0px;
  font-size: 12px;
  background: #fff;
  box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0.15),
    1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  text-align: right;
}

.ck-focused {
  border: 1px solid !important;
  border-color: blue;
  box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0.15),
    1px 1px 2px 2px rgba(0, 0, 0, 0.1) !important;
  overflow: visible;
}

.ck,
.ck-file-dialog-button {
  overflow: visible;
}

.ck h1 {
  font-size: 1.8em;
  font-weight: 700;
}
.ck h2 {
  font-size: 1.6em;
  font-weight: 700;
}
.ck h3 {
  font-size: 1.4em;
  font-weight: 700;
}
.ck h4 {
  font-size: 1.2em;
  font-weight: 500;
}
</style>
